import { Config } from '../config/config';
import { SAND_EVENT_IDS } from '../config/constants';
import ar from '../languages/ar';

import SandImg from '../../www/assets/images/sand_movement.jpg';
import SandImg2 from '../../www/assets/images/sand_movement_2.png';
import MethaneLegendImg from '../../www/assets/images/methane_legend.png';

const SAND_MOVEMENT_ROUTE_PARAM = 'sand-movement';
const METHANE_EVENT_ID = 'eo_event_009900';
const METHANE_GMAP_ID = 'eo_gmap_methane';

const isAbsoluteUrl = src => /^https?:\/\//.test(src || '');

const resolveCe2s2AssetUrl = src => {
    if (!src) {
        return '';
    }

    return isAbsoluteUrl(src) ? src : `${Config.baseCe2s2Url}${src}`;
};

const SAND_MOVEMENT_ITEMS_DATA = [
    {
        id: SAND_MOVEMENT_ROUTE_PARAM,
        eventId: 'sand_1',
        title: ar.Sand_Movement,
        thumbSrc: SandImg,
        image: SandImg,
        description: ar.sand_movement_des
    }
];

// const SAND_MOVEMENT_ITEMS_DATA = [
//     {
//         id: SAND_MOVEMENT_ROUTE_PARAM,
//         eventId: 'sand_1',
//         title: ar.Sand_Movement,
//         thumbSrc: SandImg,
//         image: SandImg,
//         description: ar.sand_movement_des
//     },
//     {
    
//         id: 'sand-movement-2',
        
//         eventId: 'sand_2',
//         title: ar.Sand_Movement,
//         thumbSrc: SandImg2,
//         image: SandImg2,
//         description: ar.sand_movement_des
//     }
// ];

const getSandMovementItems = () => SAND_MOVEMENT_ITEMS_DATA;
const getSandMovementEventId = itemId => SAND_MOVEMENT_ITEMS_DATA.find(({ id }) => id === itemId)?.eventId ?? itemId;


const isSandId = id => SAND_EVENT_IDS.includes(id);

const findEventById = (events, eventId) => Object.values(events || {})
    .flatMap(yearEvents => (Array.isArray(yearEvents) ? yearEvents : []))
    .find(event => event?.id === eventId || event?.external_id === eventId || event?.urlParam === eventId) || null;

const getMethaneEvent = events => findEventById(events, METHANE_EVENT_ID);


const getSandProjectGmap = (events, eventId) => {
    const sandEvent = findEventById(events, eventId);
    const { boundaries } = sandEvent || {};

    if (!sandEvent || !boundaries) {
        return null;
    }

    const item = SAND_MOVEMENT_ITEMS_DATA.find(entry => entry.eventId === eventId);

    return {
        ...sandEvent,
        id: eventId,
        external_id: eventId,
        eventId,
        type: sandEvent.type || 'geoLocated',
        title: item?.title || sandEvent.title || ar.Sand_Movement,
        date: sandEvent.date,
        formatted_date: sandEvent.formatted_date,
        description: item?.description || sandEvent.description,
        north_boundary: boundaries.north,
        south_boundary: boundaries.south,
        east_boundary: boundaries.east,
        west_boundary: boundaries.west,
        center: Array.isArray(boundaries.center) ? boundaries.center.join(', ') : '',
        distance_from_gmap: sandEvent.distance_from_event || 20,
        image_src: sandEvent.src || sandEvent.list_image_src || '',
        list_image_src: resolveCe2s2AssetUrl(sandEvent.list_image_src || sandEvent.thumbSrc || sandEvent.src),
        transparent: sandEvent.transparent !== false,
        imagecategory: 'geographical,sand'
    };
};

const getMethaneProjectGmap = events => {
	const methaneEvent = getMethaneEvent(events);
	const { boundaries } = methaneEvent || {};

	if (!methaneEvent || !boundaries) {
		return null;
	}
	return {
        id: METHANE_GMAP_ID,
        external_id: METHANE_GMAP_ID,
        type: 'geoLocated',
        title: methaneEvent.title || ar.Methane,
        date: methaneEvent.date,
        formatted_date: methaneEvent.formatted_date,
        description: ar.Methane_des || methaneEvent.description,
        north_boundary: Number(boundaries.north),
        south_boundary: Number(boundaries.south),
        east_boundary: Number(boundaries.east),
        west_boundary: Number(boundaries.west),
        center: Array.isArray(boundaries.center) ? boundaries.center.join(', ') : '',

        distance_from_gmap: 20,
     
        boundaries: {
            north: Number(boundaries.north),
            south: Number(boundaries.south),
            east: Number(boundaries.east),
            west: Number(boundaries.west),
            center: boundaries.center
        },
        src: methaneEvent.src,
        images: methaneEvent.images,
        animation_speed: methaneEvent.animation_speed,
        image_src: methaneEvent.src || methaneEvent.list_image_src || '',
        list_image_src: resolveCe2s2AssetUrl(methaneEvent.list_image_src || methaneEvent.thumbSrc || methaneEvent.src),
        legendImage: MethaneLegendImg,
        legendAlt: 'methane legend',
        transparent: methaneEvent.transparent !== false,
        imagecategory: 'geographical,methane'
    };
};

const getProjectGmapByParam = ({ gmaps, events, gmapParam }) => {
    if (gmapParam === METHANE_GMAP_ID) {
        return getMethaneProjectGmap(events);
    }

    if (isSandId(gmapParam)) {
        return getSandProjectGmap(events, gmapParam);
    }

    return Array.isArray(gmaps)
        ? gmaps.find(gmap => gmap.external_id === gmapParam) || null
        : null;
};

export {
    SAND_MOVEMENT_ROUTE_PARAM,
    METHANE_GMAP_ID,
    getSandMovementItems,
    getSandMovementEventId,
    getSandProjectGmap,
    getMethaneProjectGmap,
    getProjectGmapByParam
};

